import React from 'react'

interface CrossProps {
    height?: number
    width?: number
    crossColor?: string
    fill?: string
    stroke?: string
    strokeWidth?: number
}

const Cross: React.FC<CrossProps> = ({
    height,
    width,
    crossColor,
    fill,
    stroke,
    strokeWidth
}) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width}
            height={height}
            fill={`${fill ? fill : 'none'}`}
            viewBox='0 0 24 24'
        >
            <path
                stroke={stroke ? stroke : crossColor}
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={strokeWidth ?? 2}
                d='M18 6l-6 6m0 0l-6 6m6-6L6 6m6 6l6 6'
            ></path>
        </svg>
    )
}

Cross.defaultProps = {
    height: 18,
    width: 18,
    crossColor: '#3366CC',
    strokeWidth: 2
}

export default Cross
